module.exports = __webpack_public_path__ + "img/appAsset-flag--PE.5322c371.svg";